import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4bfd5884 = () => interopDefault(import('../../../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _ddb8d87e = () => interopDefault(import('../../../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _46362990 = () => interopDefault(import('../../../pages/account/alerts.vue' /* webpackChunkName: "pages/account/alerts" */))
const _abfbc6ee = () => interopDefault(import('../../../pages/account/newsletters.vue' /* webpackChunkName: "pages/account/newsletters" */))
const _64534604 = () => interopDefault(import('../../../pages/account/newsletters-archive.vue' /* webpackChunkName: "pages/account/newsletters-archive" */))
const _d0f056f4 = () => interopDefault(import('../../../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _2948ac08 = () => interopDefault(import('../../../pages/account/research.vue' /* webpackChunkName: "pages/account/research" */))
const _0a86e640 = () => interopDefault(import('../../../pages/article-binder.vue' /* webpackChunkName: "pages/article-binder" */))
const _7216d249 = () => interopDefault(import('../../../pages/calendars/index.vue' /* webpackChunkName: "pages/calendars/index" */))
const _22f482a7 = () => interopDefault(import('../../../pages/debug/index.vue' /* webpackChunkName: "pages/debug/index" */))
const _2d53b88a = () => interopDefault(import('../../../pages/dossiers/index.vue' /* webpackChunkName: "pages/dossiers/index" */))
const _7c364fda = () => interopDefault(import('../../../pages/in-short.vue' /* webpackChunkName: "pages/in-short" */))
const _539e8850 = () => interopDefault(import('../../../pages/jobs/index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _4a906717 = () => interopDefault(import('../../../pages/payment.vue' /* webpackChunkName: "pages/payment" */))
const _14c2fba7 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _244d6d72 = () => interopDefault(import('../../../pages/subscriptions.vue' /* webpackChunkName: "pages/subscriptions" */))
const _7bc028ce = () => interopDefault(import('../../../pages/admin/image-search.vue' /* webpackChunkName: "pages/admin/image-search" */))
const _04e38fde = () => interopDefault(import('../../../pages/auth/google.vue' /* webpackChunkName: "pages/auth/google" */))
const _30d39056 = () => interopDefault(import('../../../pages/auth/linkedin.vue' /* webpackChunkName: "pages/auth/linkedin" */))
const _2b9d1742 = () => interopDefault(import('../../../pages/dossiers/_slug.vue' /* webpackChunkName: "pages/dossiers/_slug" */))
const _570bcae0 = () => interopDefault(import('../../../pages/jobs/_slug.vue' /* webpackChunkName: "pages/jobs/_slug" */))
const _1678ed89 = () => interopDefault(import('../../../pages/page/_slug.vue' /* webpackChunkName: "pages/page/_slug" */))
const _6a76bc00 = () => interopDefault(import('../../../pages/pagina/_slug.vue' /* webpackChunkName: "pages/pagina/_slug" */))
const _77002223 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _e039a0a0 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _4bfd5884,
    meta: {"scrollToTop":true},
    children: [{
      path: "",
      component: _ddb8d87e,
      meta: {"scrollToTop":true,"fetchOnServer":false},
      name: "account"
    }, {
      path: "alerts",
      component: _46362990,
      meta: {"scrollToTop":true,"validations":{"alert":{"maxResults":{},"displayText":{},"languageId":{}}}},
      name: "account-alerts"
    }, {
      path: "newsletters",
      component: _abfbc6ee,
      meta: {},
      name: "account-newsletters"
    }, {
      path: "newsletters-archive",
      component: _64534604,
      meta: {},
      name: "account-newsletters-archive"
    }, {
      path: "orders",
      component: _d0f056f4,
      meta: {"scrollToTop":true},
      name: "account-orders"
    }, {
      path: "research",
      component: _2948ac08,
      meta: {"scrollToTop":true},
      name: "account-research"
    }]
  }, {
    path: "/article-binder",
    component: _0a86e640,
    meta: {"scrollToTop":true},
    name: "article-binder"
  }, {
    path: "/calendars",
    component: _7216d249,
    meta: {"name":"Calendars","scrollToTop":true,"fetchOnServer":false},
    name: "calendars"
  }, {
    path: "/debug",
    component: _22f482a7,
    meta: {"layout":"blank","scrollToTop":true,"auth":false},
    name: "debug"
  }, {
    path: "/dossiers",
    component: _2d53b88a,
    meta: {"name":"DossierList","scrollToTop":true,"fetchOnServer":false},
    name: "dossiers"
  }, {
    path: "/in-short",
    component: _7c364fda,
    meta: {"name":"InShortPage","layout":"generic","scrollToTop":true,"fetchOnServer":true},
    name: "in-short"
  }, {
    path: "/jobs",
    component: _539e8850,
    meta: {"name":"JobList","scrollToTop":true,"fetchOnServer":false},
    name: "jobs"
  }, {
    path: "/payment",
    component: _4a906717,
    meta: {"name":"Payment","scrollToTop":true,"fetchOnServer":false,"fetchKey":"payments","validations":{"user":{"company":{},"firstName":{},"lastName":{},"address":{},"postcode":{},"city":{},"idCountry":{},"phoneNumber":{},"vat":{}},"invoice":{"poNumber":{}},"paymentInvoice":{"email":{},"name":{},"company":{},"address":{},"postcode":{},"city":{},"countryId":{}}}},
    name: "payment"
  }, {
    path: "/search",
    component: _14c2fba7,
    meta: {"name":"SearchPage","fetchOnServer":false},
    name: "search"
  }, {
    path: "/subscriptions",
    component: _244d6d72,
    meta: {"name":"Subscriptions","scrollToTop":true},
    name: "subscriptions"
  }, {
    path: "/admin/image-search",
    component: _7bc028ce,
    meta: {"name":"ImageSearchPage","scrollToTop":true,"fetchOnServer":false},
    name: "admin-image-search"
  }, {
    path: "/auth/google",
    component: _04e38fde,
    meta: {"name":"GoogleLoginCallback","auth":"guest","layout":"blank"},
    name: "auth-google"
  }, {
    path: "/auth/linkedin",
    component: _30d39056,
    meta: {"name":"LinkedInLoginCallback","auth":"guest","layout":"blank"},
    name: "auth-linkedin"
  }, {
    path: "/dossiers/:slug",
    component: _2b9d1742,
    meta: {"name":"Dossier","fetchOnServer":false,"scrollToTop":true},
    name: "dossiers-slug"
  }, {
    path: "/jobs/:slug",
    component: _570bcae0,
    meta: {"name":"Job","fetchOnServer":false,"scrollToTop":true},
    name: "jobs-slug"
  }, {
    path: "/page/:slug?",
    component: _1678ed89,
    meta: {},
    name: "page-slug"
  }, {
    path: "/pagina/:slug?",
    component: _6a76bc00,
    meta: {},
    name: "pagina-slug"
  }, {
    path: "/",
    component: _77002223,
    meta: {"name":"HomePage","fetchOnServer":false,"scrollToTop":true},
    name: "index"
  }, {
    path: "/*",
    component: _e039a0a0,
    meta: {},
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
